export const Correct = () => {
  return (
    <svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y={0.5} width={18} height={18} rx={9} fill="#089E6F" />
      <path
        d="M6.074 9.792l1.755 1.755 4.095-4.095"
        stroke="#fff"
        strokeWidth={1.13657}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Wrong = () => {
  return (
    <svg
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0C4.256 0 0 4.256 0 9.5S4.256 19 9.5 19 19 14.744 19 9.5 14.744 0 9.5 0zm.95 14.25h-1.9v-5.7h1.9v5.7zm0-7.6h-1.9v-1.9h1.9v1.9z"
        fill="#CC4242"
      />
    </svg>
  );
};

export const Play = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={18} fill="#127FBE" />
      <path d="M13.935 9.451v15.995l12.568-7.997L13.935 9.45z" fill="#fff" />
    </svg>
  );
};

export const Pause = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={36} height={36} rx={18} fill="#127FBE" />
      <path
        d="M14 11C13.4477 11 13 11.4477 13 12V24C13 24.5523 13.4477 25 14 25H15C15.5523 25 16 24.5523 16 24V12C16 11.4477 15.5523 11 15 11H14ZM20 11C19.4477 11 19 11.4477 19 12V24C19 24.5523 19.4477 25 20 25H21C21.5523 25 22 24.5523 22 24V12C22 11.4477 21.5523 11 21 11H20Z"
        fill="#fff"
      />
    </svg>
  );
};

export const Send = () => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.51 18.03l7.51 3.22-7.52-1 .01-2.22zm7.5 8.72l-7.51 3.22v-2.22l7.51-1zM13.51 15l-.01 7 15 2-15 2 .01 7 20.99-9-20.99-9z"
        fill="#A9AEB2"
      />
    </svg>
  );
};

export const SendFocused = () => {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={48} height={48} rx={8} fill="#127FBE" />
      <path
        d="M15.51 18.03l7.51 3.22-7.52-1 .01-2.22zm7.5 8.72l-7.51 3.22v-2.22l7.51-1zM13.51 15l-.01 7 15 2-15 2 .01 7 20.99-9-20.99-9z"
        fill="#fff"
      />
    </svg>
  );
};
